import { createContext } from 'react';
import { Question, responseValidateQuestion } from '../../interfaces';

interface ContextProps {
  questions: Question[];
  activeQuestion: Question | null;
  missingResponse: boolean;
  isLoadTrivia: boolean;
  result: responseValidateQuestion[] | null;
  isOpenTrivia: boolean;
  triviaId: number | null;
  timeElapsed: number;
  timerRunning: boolean;
  setTimeElapsed: (time: number) => void;
  setTimerRunning: (running: boolean) => void;
  attempt: number;
  incrementAttempt: () => void;
  resetAttempt: () => void;

  // Métodos existentes
  setTrivia: (questions: Question[]) => void;
  setTriviaId: (id: number) => void;
  setCurrentQuestion: (question: Question) => void;
  selectQuestion: (question: Question, responseId: string) => void;
  setMissingResponse: (newStatus: boolean) => void;
  saveResponseTrivia: (response: responseValidateQuestion[]) => void;
  setLoadTrivia: () => void;
  onOpenTrivia: () => void;
  onCloseAndClearTrivia: () => void;
  retryTriviaState: () => void;
}

export const TriviaContext = createContext({} as ContextProps);
